"use strict";
import Ports from "./hubtran/ports";
function preventScroll(e) {
  switch (e.key) {
    case "ArrowUp":
    case "ArrowDown":
    case "ArrowLeft":
    case "ArrowRight":
    case " ":
      e.preventDefault();
      break;
    default:
      break;
  }
}
const disableScrollByContainerId = (containerId) => {
  const container = document.getElementById(containerId);
  if (container) {
    container.addEventListener("keydown", preventScroll, false);
  }
};
const scrollToId = (payload) => {
  const list = document.getElementById(payload.listId);
  if (!list) {
    return;
  }
  const optionElement = Array.from(
    list.querySelectorAll("li[data-option]")
  ).find((option) => option.getAttribute("data-option") === payload.optionId);
  if (optionElement) {
    optionElement.scrollIntoView({ block: "nearest", inline: "nearest" });
  }
};
const applyPorts = (app) => {
  const ports = new Ports(app);
  ports.safeSubscribe(
    "v3DisableScrollByContainerId",
    disableScrollByContainerId
  );
  ports.safeSubscribe("v3ScrollToId", scrollToId);
};
const UiV3 = { applyPorts };
export default UiV3;
